import React from "react";
import { useNavigate } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { trpcClient } from "@/lib/trpc";
import ReceiptForm from "./ReceiptForm";
import StandardDetailLayout from "@/layouts/StandardDetailLayout";

export default function ReceiptCreatePage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleSubmit = async (data: any) => {
    try {
      await trpcClient.receipts.create.mutate(data);

      await queryClient.invalidateQueries({ queryKey: ["receipts"] });
      await queryClient.invalidateQueries({ queryKey: ["customer-debts"] });
      navigate({ to: "/finance/receipts" });
    } catch (error: any) {
      toast.error(error?.message || "Có lỗi xảy ra khi lưu");
    }
  };

  return (
    <StandardDetailLayout
      breadcrumbs={[
        { label: "Phiếu Thu", to: "/finance/receipts" },
        { label: "Tạo mới" },
      ]}
      title="Tạo Phiếu Thu Mới"
      onBack={() => navigate({ to: "/finance/receipts" })}
      showContextPanel={false}
    >
      <div className="p-4 md:p-6 w-full mx-auto">
        <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-xs">
          <ReceiptForm
            onSubmit={handleSubmit}
            onCancel={() => navigate({ to: "/finance/receipts" })}
            submitLabel="Lưu"
          />
        </div>
      </div>
    </StandardDetailLayout>
  );
}
